import {isAucWithoutGfr} from '@/modules/patients-therapies/functions'
import {useGetPatientLatestGfrLab} from '@/modules/patients/api/use-get-patient-latest-gfr-lab'
import {PatientTherapySequence} from '@cypro/engine/schema'

export function useIsValidationBlockedByGfr(sequence: PatientTherapySequence) {
  const [latestGfrLab] = useGetPatientLatestGfrLab(sequence.patientId)
  return isAucWithoutGfr(sequence.medicine, latestGfrLab?.gfr)
}
